import dayjs from 'dayjs';

export const formatDateUpper = (date: string) => {
  if (!date) {
    return '';
  }

  return dayjs(date).format('MMM.DD YYYY').toUpperCase();
};

export const formatDate = (date: string) => {
  if (!date) {
    return '';
  }

  return dayjs(date).format('MMM D, YYYY');
};
